(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function findQtyInput(scope) {
    // Works for Dawn/new themes
    return qs(scope, 'input[name="quantity"]');
  }

  function renameQtyLabel(scope) {
    // Best-effort label rename in Dawn-like themes
    const label =
      qs(scope, 'label[for^="Quantity-"]') ||
      qs(scope, '.quantity__label') ||
      qs(scope, 'quantity-input label') ||
      qs(scope, '.product-form__input label');

    if (label) label.textContent = 'Pallets';
  }

  function forceWholePallets(qtyInput) {
    if (!qtyInput) return;
    qtyInput.step = 1;
    qtyInput.min = 1;
    const v = parseInt(qtyInput.value || '1', 10);
    qtyInput.value = String(Number.isFinite(v) && v >= 1 ? v : 1);
  }

  function initOneHelper(helperEl) {
    if (!helperEl || helperEl.__tcInited) return;
    helperEl.__tcInited = true;

    const scope = helperEl.closest('product-info, .product, .shopify-section') || document;

    const sqmPerPallet = parseFloat(helperEl.dataset.sqmPerPallet || '0');
    const boxesPerPallet = parseInt(helperEl.dataset.boxesPerPallet || '0', 10);

    if (!sqmPerPallet || !boxesPerPallet) return;

    const qtyInput = findQtyInput(scope);
    renameQtyLabel(scope);
    forceWholePallets(qtyInput);

    const areaInput = qs(helperEl, '[data-tc-area]');
    const wastage = qs(helperEl, '[data-tc-wastage]');
    const summary = qs(helperEl, '[data-tc-summary]');
    const outQty = qs(helperEl, '[data-tc-pallet-qty]');
    const outSqm = qs(helperEl, '[data-tc-total-sqm]');
    const outBoxes = qs(helperEl, '[data-tc-total-boxes]');

    function showSummary() {
      if (summary) summary.hidden = false;
    }

    function refreshFromQty() {
      if (!qtyInput) return;
      let pallets = parseInt(qtyInput.value || '1', 10);
      if (!Number.isFinite(pallets) || pallets < 1) pallets = 1;

      qtyInput.value = String(pallets);

      if (outQty) outQty.textContent = String(pallets);
      if (outSqm) outSqm.textContent = (pallets * sqmPerPallet).toFixed(2);
      if (outBoxes) outBoxes.textContent = String(pallets * boxesPerPallet);

      showSummary();
    }

    function calcFromArea() {
      if (!areaInput || !qtyInput) return;

      let req = parseFloat(areaInput.value || '0');
      if (wastage && wastage.checked) req = req * 1.10;

      if (!Number.isFinite(req) || req <= 0) {
        // If user clears input, don’t break qty; just hide summary (optional)
        // (We keep summary visible if qty already set)
        return;
      }

      const palletsNeeded = Math.max(1, Math.ceil(req / sqmPerPallet));
      qtyInput.value = String(palletsNeeded);
      refreshFromQty();
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', () => {
        forceWholePallets(qtyInput);
        refreshFromQty();
      });

      // Some themes change qty via +/- buttons without input event
      qtyInput.addEventListener('change', () => {
        forceWholePallets(qtyInput);
        refreshFromQty();
      });

      refreshFromQty();
    }

    if (areaInput) areaInput.addEventListener('input', calcFromArea);
    if (wastage) wastage.addEventListener('change', calcFromArea);

    // If variants cause rerender, run again safely
    qsa(scope, 'select, input[type="radio"]').forEach(el => {
      el.addEventListener('change', () => {
        renameQtyLabel(scope);
        forceWholePallets(qtyInput);
        refreshFromQty();
      });
    });
  }

  function initAll(root) {
    qsa(root || document, '[data-tc-pallet-helper]').forEach(initOneHelper);
  }

  // Initial
  document.addEventListener('DOMContentLoaded', () => initAll(document));

  // Shopify section reloads (theme editor / dynamic renders)
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:reorder', (e) => initAll(e.target));

  // Mutation observer for safety (some themes replace product form)
  const mo = new MutationObserver(() => initAll(document));
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
